<template>
<svg viewBox="0 0 32 32" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-BanGongShi`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M4 3.5C3.72386 3.5 3.5 3.72386 3.5 4V10C3.5 10.2761 3.72386 10.5 4 10.5H17C17.2761 10.5 17.5 10.2761 17.5 10V4C17.5 3.72386 17.2761 3.5 17 3.5H4zM2.5 4C2.5 3.17157 3.17157 2.5 4 2.5H17C17.8284 2.5 18.5 3.17157 18.5 4V10C18.5 10.8284 17.8284 11.5 17 11.5H4C3.17157 11.5 2.5 10.8284 2.5 10V4zM30 16H2V18H30V16zM2 15C1.44772 15 1 15.4477 1 16V18C1 18.5523 1.44772 19 2 19H30C30.5523 19 31 18.5523 31 18V16C31 15.4477 30.5523 15 30 15H2z"/><path d="M3 19H6V31H3V19Z"/><path fill-rule="evenodd" clip-rule="evenodd" d="M28 19H19V30H28V19ZM18 18V31H29V18H18Z"/><path d="M19 23.5H28V25.5H19V23.5zM9.5 11H11.5V15H9.5V11z"/></svg>
</template>
<script>

export default {
  name: 'IconBanGongShi',
  props: {
    prefix: {
        type: String,
        default: 'LAIDO',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
